import { IconSvg, IconSvgProps } from "./icon"

export default function PlaneMultiTrip(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeModifier={0.875}>
      <path d="m10.885 19.378-1.014.331M7.842 20.37l-1.014.331M3.529 5.094l1.37-.44a.46.46 0 0 1 .51.17l.94 1.49 5.162-2.57a3.241 3.241 0 0 1 4.672 1.65.88.88 0 0 1-.58 1.1L12.21 7.596l-.34.11-.64 2.19a.45.45 0 0 1-.31.321l-1.54.5a.48.48 0 0 1-.66-.54l.32-1.56-.22.07-3.312 1.07a.86.86 0 0 1-1.11-.52l-1.16-3.601a.44.44 0 0 1 .29-.54ZM8.085 12.614l1.37-.44a.46.46 0 0 1 .51.17l.941 1.49 5.162-2.57a3.24 3.24 0 0 1 4.671 1.65.88.88 0 0 1-.58 1.1l-3.391 1.1-.34.11-.64 2.19a.45.45 0 0 1-.31.321l-1.541.5a.48.48 0 0 1-.66-.54l.32-1.56-.22.07-3.311 1.07a.86.86 0 0 1-1.11-.52l-1.16-3.601a.44.44 0 0 1 .29-.54ZM14.823 8.77l1.009-.349M17.848 7.725l1.008-.348" />
    </IconSvg>
  )
}
